import { Directive, ElementRef, AfterViewInit } from '@angular/core';

declare var vl: any;

@Directive({
    selector: '[appWuDatepicker]',
    standalone: false
})
export class WuDatepickerDirective implements AfterViewInit {

  constructor(private elementRef: ElementRef) { }

  ngAfterViewInit() {
    vl.datepicker.dress(this.elementRef.nativeElement);
  }
}
